import { ol_Feature, ol_style, ol_geom } from "@omnia/exports/openlayers";

export class EditLayer extends omnia.map.Layer {


    private _style: any;


    constructor(private newFeatureWatcher: (feature: any) => void) {

        super();

        this._style = new ol_style.Style({

            fill: new ol_style.Fill({ color: [255, 255, 255, 0.5] }),

            stroke: new ol_style.Stroke({
                color: ([0, 0, 0, 1]),
                width: (1),
                lineDash: [3, 3]
            })

        });


        if (newFeatureWatcher) {
            this._source.on("addfeature", e => newFeatureWatcher(e.feature));
        }

    }


    addNewFeature(geometry: any) {

        var f = new ol_Feature({ geometry: geometry });
        f.setId(1 + this._source.getFeatures().length);
        f.set("layer", this);
        f.setStyle(this._style);

        this._source.addFeatures([f]);

        return f;


    }


    getGeometries(): ol_geom.Geometry[] {

        return this._source.getFeatures().map(f => f.getGeometry());

    }

    setGeometries(geometries: any[]) {

        this._source.clear();

        geometries.forEach(g => this.addNewFeature(g));

    }

    removeFeature(feature: any) {

        this._source.removeFeature(feature);

    }
}
